import { ApiCore } from '@/services/api/utils/core.js';
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = `subscriptions`
const plural = 'subscriptions'
const single = 'subscription'

const api = new ApiCore({
	index: true,
    findOne: false,
    findAll: false,
	create: true,
	update: true,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.updateParticipantSubscription = (participantId, useCaseId, dataElementId, type, params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${participantId}/${useCaseId}/${dataElementId}/${type}/principals`, params)
		.then(handleResponse)
		.catch(handleError);
}

export default api
